import { Link } from 'react-router-dom';
import { Hero } from '../components/sections/Hero';
import { ToolMarquee } from '../components/sections/ToolMarquee';
import { StatsStrip } from '../components/sections/StatsStrip';
import { ServicesExplorer } from '../components/sections/ServicesExplorer';
import { DeliveryModel } from '../components/sections/DeliveryModel';
import { ProjectGallery } from '../components/sections/ProjectGallery';
import { ContactCTA } from '../components/sections/ContactCTA';
import { WHY } from '../data/siteData';
import { Reveal } from '../hooks/useMotion';

export const HomePage = () => (
  <div data-testid="home-page">
    <Hero />
    <ToolMarquee />
    <StatsStrip />

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Why BuildiTech</div>
          <h2>BIM support designed for better coordination, fewer errors and smoother delivery</h2>
        </Reveal>
        <div className="why">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={i * 80}>
              <h3>{w.title}</h3>
              <p>{w.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <Reveal className="hd-row">
          <div className="hd">
            <div className="mono">Services</div>
            <h2>End-to-end BIM support</h2>
            <p>From design coordination to construction documentation. Choose a service to see what we deliver.</p>
          </div>
          <Link to="/services" className="btn btn-g">All services <span className="ar">→</span></Link>
        </Reveal>
        <ServicesExplorer />
      </div>
    </section>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Our delivery model</div>
          <h2>Controlled delivery, not unmanaged outsourcing</h2>
          <p>BuildiTech leadership keeps technical ownership for the whole project.</p>
        </Reveal>
        <DeliveryModel />
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <Reveal className="hd-row">
          <div className="hd">
            <div className="mono">Project case studies</div>
            <h2>Built in BIM before it&apos;s built on site</h2>
          </div>
          <Link to="/projects" className="btn btn-g">All projects <span className="ar">→</span></Link>
        </Reveal>
        <ProjectGallery limit={6} showFilters={false} />
      </div>
    </section>

    <ContactCTA />
  </div>
);

export default HomePage;
